<template>
    <div class="animated fadeIn">
        <div v-if="isLoading">
            <b-row>
                <b-col md="6">
                    <atom-spinner
                        :animation-duration="1000"
                        :size="60"
                        color="#ff1d5e"
                        class="float-right my-4"
                    />
                </b-col>
            </b-row>
        </div>
        <b-row class="mb-3" v-if="!isLoading">
            <b-col md="5"><h3>Subscription</h3> </b-col>
            <b-col md="4">
                <b-form-input
                    class="searchField"
                    v-model="filter"
                    placeholder="Search plan name or amount"
                />
                <eb-button
                    class="searchIcon"
                    classic="btn-light"
                    icon="fa fa-search"
                    :disabled="!filter"
                    @click="filter"
                    text=""
                ></eb-button>
            </b-col>
            <b-col md="2">
                <b-button block variant="primary" @click="handleSubscription"
                    >Add &nbsp;Subscription</b-button
                >
            </b-col>
            <b-col md="1">
                <b-button
                    size="sm"
                    variant="success"
                    @click="reloadData"
                    :disabled="isLoading"
                >
                    <span
                        v-if="isLoading"
                        class="fa fa-refresh fa-spin"
                        style="font-size: 15px"
                    />
                    <span
                        v-else
                        class="fa fa-refresh"
                        style="font-size: 15px"
                    />
                </b-button>
            </b-col>
        </b-row>
        <b-card class="card-wrap" border-variant="info" v-if="!isLoading">
            <b-row>
                <b-col md="12">
                    <b-table
                        style="border-radius: 12px"
                        responsive
                        :dark="dark"
                        :hover="hover"
                        :striped="striped"
                        :bordered="bordered"
                        :small="small"
                        :fixed="fixed"
                        class="tableRadius"
                        :items="subscriptionList"
                        :fields="fields"
                        :current-page="currentPage"
                        :filter="filter"
                        thead-class="header"
                        show-empty
                        :busy="isLoading"
                        :outlined="true"
                        :per-page="perPage"
                        @filtered="onFiltered"
                    >
                        <template slot="cell(actions)" slot-scope="data">
                            <div class="d-flex">
                                <div>
                                    <b-button
                                        size="sm"
                                        class="mr-2 button-circle"
                                        style="
                                            background: #fe7b08;
                                            border: #fe7b08;
                                        "
                                        variant="primary"
                                        @click="
                                            editClick(
                                                data.item._id,
                                                data.item.planName,
                                                data.item.pricing.price,
                                                data.item.planDescription,
                                            )
                                        "
                                    >
                                        <i class="fa fa-pencil"></i>
                                    </b-button>
                                </div>

                                <div>
                                    <b-button
                                        size="sm"
                                        class="mr-2 button-circle"
                                        variant="danger"
                                        @click="deleteClick(data.item._id)"
                                    >
                                        <i class="fa fa-trash bin"></i>
                                    </b-button>
                                </div>
                            </div>
                        </template>

                        <template #row-details="row">
                            <b-card>
                                <ul>
                                    <li
                                        v-for="(value, key) in row.item"
                                        :key="key"
                                    >
                                        <div class="mt-2">
                                            {{ key }}: {{ value }}
                                        </div>
                                    </li>
                                </ul>
                            </b-card>
                        </template>
                    </b-table>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="12">
                    <div style="float: right" v-if="totalRows > perPage">
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="totalRows"
                            :per-page="perPage"
                            align="center"
                            size="md"
                            class="my-0 center"
                            prev-text="Prev"
                            next-text="Next"
                            hide-goto-end-buttons
                        ></b-pagination>
                    </div>
                </b-col>
            </b-row>
        </b-card>
        <b-modal
            id="modalAdd"
            v-model="showModal"
            centered
            title="Add New Subscription"
            header-class="mb-3 header-text"
            footer-class="border-0 footer-button"
            modal-class="p-3"
            hide-footer
            ref="field-modal"
        >
            <ValidationObserver ref="observer">
                <b-row>
                    <b-col md="6" class="pb-0">
                        <label for=" Plan Name"> Plan Name:</label>
                        <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            name="Plan Name"
                            :key="resetKey"
                        >
                            <b-form-input
                                v-model="addPayload.planName"
                                placeholder="Enter Plan Name"
                            ></b-form-input>
                            <span class="validate-error" style="color: red">{{
                                errors[0]
                            }}</span>
                        </ValidationProvider>
                    </b-col>

                    <b-col md="6" class="pb-0">
                        <label for=" Plan Amount "> Plan Amount:</label>
                        <ValidationProvider
                            rules="required|numeric"
                            v-slot="{ errors }"
                            name="Plan Amount"
                            :key="resetKey"
                        >
                            <b-form-input
                                v-model="addPayload.pricing.price"
                                maxlength="6"
                                placeholder="Enter Plan Amount"
                            ></b-form-input>
                            <span class="validate-error" style="color: red">{{
                                errors[0]
                            }}</span>
                        </ValidationProvider>
                    </b-col>
                    <b-col md="12" class="pb-0 mt-2">
                        <label for="Description">Description:</label>
                        <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            name="Description"
                            :key="resetKey"
                        >
                            <b-form-input
                                v-model="addPayload.planDescription"
                                inputType="text"
                                maxlength="100"
                                placeholder="Enter Description"
                            ></b-form-input>
                            <span class="validate-error" style="color: red">{{
                                errors[0]
                            }}</span>
                        </ValidationProvider>
                    </b-col>
                </b-row>
                <b-row class="mt-4 mb-1">
                    <b-col md="1"></b-col>
                    <b-col md="5">
                        <b-button
                            style="width: 100px; margin-left: 70px"
                            variant="danger"
                            block
                            @click="CancelButton"
                            >CANCEL</b-button
                        ></b-col
                    >
                    <b-col md="5">
                        <b-button
                            style="width: 100px"
                            variant="primary"
                            block
                            @click="saveSubscription"
                            >SAVE</b-button
                        >
                    </b-col>
                    <b-col md="1"></b-col>
                </b-row>
            </ValidationObserver>
        </b-modal>

        <!--Update-->
        <b-modal
            id="modalUpdate"
            v-model="showModalEdit"
            centered
            title="Update Subscription"
            header-class="mb-3 header-text"
            footer-class="border-0 footer-button"
            modal-class="p-3"
            hide-footer
            ref="field-modal"
        >
            <b-row>
                <b-col md="6" class="pb-0">
                    <label for=" Plan Name "> Plan Name:</label>
                    <b-form-input
                        v-model="updatePayload.planName"
                        placeholder="Enter Plan Name"
                    ></b-form-input>
                </b-col>
                <b-col md="6" class="pb-0">
                    <label for=" Plan Amount "> Plan Amount:</label>
                    <b-form-input
                        v-model="updatePayload.pricing.price"
                        placeholder="Enter Plan Amount"
                        maxlength="6"
                    ></b-form-input>
                    <p v-if="isValidUpdateAmount" class="is-valid-amount">
                        Amount should be Numeric
                    </p>
                </b-col>
                <b-col md="12" class="mt-2 pb-0">
                    <label for="Description"> Description:</label>
                    <b-form-input
                        v-model="updatePayload.planDescription"
                        placeholder="Enter Description"
                    ></b-form-input
                ></b-col>
            </b-row>
            <b-row class="mt-4 mb-1">
                <b-col md="1"></b-col>
                <b-col md="5">
                    <b-button
                        variant="danger"
                        block
                        @click="showModalEdit = false"
                        style="width: 100px; margin-left: 70px"
                        >CANCEL</b-button
                    ></b-col
                >
                <b-col md="5">
                    <b-button
                        style="width: 100px"
                        variant="primary"
                        block
                        @click="updateSubscription"
                        >Update</b-button
                    >
                </b-col>
                <b-col md="1"></b-col>
            </b-row>
        </b-modal>
    </div>
</template>
<script>
import { mapState } from "vuex";
import currentUserData from "@/mixins/currentUser";
import ebButton from "@/components/FormElements/Button";
import { AtomSpinner } from "epic-spinners";
import { ValidationProvider, ValidationObserver } from "vee-validate";
export default {
    mixins: [currentUserData],
    components: {
        ebButton,
        AtomSpinner,
        ValidationProvider,
        ValidationObserver,
    },
    data() {
        return {
            resetKey: 0,
            hover: true,
            striped: false,
            bordered: true,
            small: false,
            fixed: false,
            dark: false,
            currentUserData: "",
            subsId: "",
            addPayload: {
                scope: "",
                planName: "",
                planDescription: "",
                planFeatures: ["feature a", "feature b", "feature c"],
                provisioning: {
                    planType: "DURATION",
                    validity: 1,
                },
                planAccess: "",
                taxCode: "123456",
                chargeCode: "SMART_CHARGE",
                paymentType: "PRE-PAID",
                autoRenewal: true,
                pricing: {
                    cadence: "MONTHLY",
                    price: "",
                    currency: "INR",
                    uom: "OCCURRENCE",
                    baseQuantity: 1,
                },
                isActive: true,
            },
            updatePayload: {
                planName: "",
                planDescription: "",
                pricing: {
                    price: "",
                },
            },
            isLoading: false,
            filter: "",
            fields: [
                {
                    key: "planName",
                    label: "Plan Name",
                    sortable: true,
                    sortDirection: "desc",
                    tdClass: "pt-2",
                    thStyle: { width: "28%" },
                    class: "text-center",
                },
                {
                    key: "pricing.price",
                    label: "Plan Amount",
                    class: "text-center",
                    tdClass: "pt-2",
                },
                {
                    key: "planDescription",
                    label: "Plan Description",
                    formatter: "shortDescription",
                    class: "textAlignment",
                },
                {
                    key: "actions",
                    label: "Action",
                    thStyle: { width: "8%" },
                    class: "text-center",
                },
            ],

            showModal: false,
            showModalEdit: false,
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
        };
    },
    computed: {
        ...mapState({
            subscriptionList: (state) =>
                state.subscription.subscriptionList.reverse(), //
        }),

        isValidAmount() {
            if (this.addPayload.pricing.price == "") return false;
            var isAmount = /^[0-9]+$/;
            if (isAmount.test(this.addPayload.pricing.price)) {
                return false;
            } else {
                return true;
            }
        },
        isValidUpdateAmount() {
            if (this.updatePayload.pricing.price == "") return false;
            var isAmount = /^[0-9]+$/;
            if (isAmount.test(this.updatePayload.pricing.price)) {
                return false;
            } else {
                return true;
            }
        },
    },
    watch: {
        search(value) {
            this.currentPage = 1;
        },
    },
    methods: {
        CancelButton() {
            this.showModal = false;
            this.addPayload.planName = "";
            this.addPayload.pricing.price = "";
            this.addPayload.planDescription = "";
        },
        handleSubscription() {
            this.showModal = true;
            this.resetKey++;
        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        shortDescription(value) {
            if (value.length > 100) {
                return value.slice(0, 100) + "" || "";
            }
            return value;
        },
        async getList() {
            this.isLoading = true;
            try {
                await this.$store.dispatch(
                    "subscription/getSubscriptionListAction",
                );
            } catch (e) {}
            this.totalRows = this.subscriptionList.length || 0;
            this.isLoading = false;
        },
        reloadData() {
            this.getList();
        },
        async saveSubscription() {
            const isValid = await this.$refs.observer.validate();
            if (!isValid) return;
            this.addPayload.planAccess = this.$currentUserData._id;
            this.addPayload.scope = this.$currentUserData.role;

            this.$store
                .dispatch("subscription/addSubscriptionAction", this.addPayload)
                .then((result) => {
                    this.$swal({
                        title: "Success",
                        text: "Subscription Plan Added Successfully!!",
                        type: "success",
                    });
                    this.reloadData();
                    this.showModal = false;
                    this.addPayload.planName = "";
                    this.addPayload.pricing.price = "";
                    this.addPayload.planDescription = "";
                })
                .catch((err) => {
                    this.$swal({
                        title: "Error",
                        text: "Please fillup required fields.",
                        type: "error",
                    });
                    this.showModal = true;
                });
        },
        editClick(id, name, price, description) {
            this.subsId = id;
            this.updatePayload.planName = name;
            this.updatePayload.pricing.price = price;
            this.updatePayload.planDescription =
                (description && description.slice(0, 60) + "") || "";
            this.showModalEdit = true;
        },
        deleteClick(id) {
            this.$swal
                .fire({
                    title: "Are you sure?",
                    text: "You won't be able to revert this!",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#3085d6",
                    confirmButtonText: " Yes,Delete it!",
                    cancelButtonColor: "#d33",
                    reverseButtons: true,
                })
                .then((result) => {
                    if (result.value) {
                        this.deleteSubscription(id);
                    }
                });
        },
        deleteSubscription(id) {
            this.$store
                .dispatch("subscription/deleteSubscriptionAction", id)
                .then(() => {
                    this.$swal({
                        title: "Success",
                        text: "Subscription Plan Deleted Successfully!!",
                        type: "success",
                    });
                    this.reloadData();
                });
        },
        updateSubscription() {
            let payload = {
                id: this.subsId,
                data: this.updatePayload,
            };
            this.$store
                .dispatch("subscription/updateSubscriptionAction", payload)
                .then(() => {
                    this.$swal({
                        title: "Success",
                        text: "Subscription Plan Updated Successfully!!",
                        type: "success",
                    });
                    this.reloadData();
                    this.showModalEdit = false;
                });
        },
    },

    mounted() {
        this.getList();
    },
};
</script>

<style>
.center {
    padding-left: auto;
}
button.btn.button-circle {
    border-radius: 50px;
    height: 32px;
    width: 32px;
    text-align: center;
    line-height: 32px;
    padding: 0;
}
.searchField {
    font-size: 12px;
    font-weight: 600;
    padding: 17px;
    height: 36px;
}

.center {
    text-align: center;
}

.headclass td {
    border-top: 1px solid #f1f5f8;
}
.description {
    color: black;
}
.round {
    border-radius: 50%;
    height: 30px;
    width: 30px;
    padding: 0;
}
.nav-tabs .nav-link.active {
    color: var(--primary);
}
.modal-content {
    padding: 1rem;
}
select.form-control:not([size]):not([multiple]) {
    height: calc(3.2125rem - 6px);
}
.modal-title {
    margin-left: 0%;
}

.table td {
    text-align: center;
}
tbody tr:nth-child(2n + 1) {
    border-bottom: 1px solid #e8e5e5;
}

td.textAlignment {
    text-align: center !important;
    white-space: pre-wrap;
}
.modal-header {
    background: #fff;
}
</style>
